module.exports = __webpack_public_path__ + "static/img/6571_phase_function_Paper_Points.6a4ac12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6571_phase_function_Paper_Points.png
// module id = sLHF
// module chunks = 0